import Vue from 'vue'

export const snippets = {
    state: {
        status: 'idle',
        snippets: {}
    },
    mutations: {
        SET_SNIPPETS_STATUS(state, payload) {
            state.status = payload
        },
        SET_SNIPPETS(state, payload) {
            Vue.set(state.snippets, payload.code, payload.data)
        }
    },
    actions: {
        async snippetsFetch({ commit }, payload) {
            try {
                const response = await this.$api(
                    `dashboard/snippets/content/${payload.code}`
                )
                if (response?.data?.data) {
                    commit('SET_SNIPPETS', {
                        data: response.data.data,
                        code: payload.code
                    })
                }
                return response
            } catch (error) {
                // console.log(error)
            }
        },
        async snippetsLoad({ commit, dispatch }, payload) {
            commit('SET_SNIPPETS_STATUS', 'loading')
            try {
                const snippets = await dispatch('snippetsFetch', payload)
                if (snippets?.data?.data) {
                    commit(
                        `SET_${payload.moduleName.toUpperCase()}_SNIPPETS`,
                        snippets.data.data
                    )
                }
            } catch (error) {
                console.log(error)
            } finally {
                commit('SET_SNIPPETS_STATUS', 'idle')
            }
        }
    },
    getters: {
        getSnippets: state => state.snippets,
        getSnippet: state => code => state.snippets[code]
    }
}
